<template>
	<v-container fluid text-xs-center class="pa-0">
		<v-layout row wrap >
      <v-flex xs12 v-if="pl === true">                      
        <youtube 
          :video-id="videoId" 
          :player-vars="playerVars"           
          @ended="ended"
          @paused="ended"
          ref="youtube"          
        ></youtube>     
         
			</v-flex><v-btn color="success" @click="play()">text</v-btn>  
		</v-layout>
	</v-container>
</template>

<script>


	export default{
		data() {
      return {
        pl: false,        
        videoId: "",
        playerVars: {
          start:0,
          autoplay: 1
        },
        
      }
    },

  computed: {
    player() {
      return this.$refs.youtube.player
    }
  },

    methods: {
      play() {   
      this.pl = true     
        this.videoId = this.$youtube.getIdFromUrl("https://www.youtube.com/watch?v=WO4nR0R6lTk")        
      },
      
      ended(){
        this.pl = false
        this.videoId = ""        
      },
    },
  }
</script>
